import {createFileRoute} from '@tanstack/react-router';
import {DeepLinkPage} from '../../pages/login/DeepLinkPage';

export const Route = createFileRoute('/deeplink/$')({
  component: DeepLinkPage,
});
